// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"30":"584751bb","78":"d42b26de","338":"07732aaf","424":"2f2b5ed0","532":"f9f1ca47","544":"3b5c0a91","576":"11044292","727":"df4fc8fe","753":"e96c7cbc","775":"3c9c5188","796":"468223d0","823":"1e6ad294","961":"95c36269","972":"7a812fae","990":"a9fec27e"}[chunkId] + ".js";
};